"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIFormControlWithActions = _interopRequireDefault(require("./UIFormControlWithActions"));

var RemovableTextInput = _react.default.createClass({
  displayName: "RemovableTextInput",
  propTypes: {
    className: _react.default.PropTypes.string,
    text: _react.default.PropTypes.string.isRequired,
    type: _react.default.PropTypes.string,
    updateTextInput: _react.default.PropTypes.func.isRequired,
    removeTextInput: _react.default.PropTypes.func.isRequired,
    validateInput: _react.default.PropTypes.func,
    invalidInputText: _react.default.PropTypes.node,
    disabled: _react.default.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      type: 'text',
      disabled: false,
      text: '',
      validateInput: function validateInput() {
        return true;
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      isValid: this.props.validateInput(this.props.text)
    };
  },
  validateAndUpdateTextInput: function validateAndUpdateTextInput(value) {
    var isValid = this.props.validateInput(value);
    this.setState({
      isValid: isValid
    });
    this.props.updateTextInput(value);
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        className = _this$props.className,
        text = _this$props.text,
        type = _this$props.type,
        removeTextInput = _this$props.removeTextInput,
        disabled = _this$props.disabled,
        invalidInputText = _this$props.invalidInputText;
    var isValid = this.state.isValid;
    return _react.default.createElement(_UIFormControlWithActions.default, {
      "data-value": text,
      className: className,
      "aria-label": "Email",
      disabled: disabled,
      error: !isValid,
      validationMessage: isValid ? null : invalidInputText,
      onRemove: removeTextInput
    }, _react.default.createElement(_UITextInput.default, {
      onChange: function onChange(_ref) {
        var value = _ref.target.value;
        return _this.validateAndUpdateTextInput(value);
      },
      onBlur: function onBlur(_ref2) {
        var value = _ref2.target.value;
        return _this.validateAndUpdateTextInput(value.trim());
      },
      type: type,
      value: text,
      className: "_email-notifications__email-text-input",
      disabled: disabled,
      error: !isValid
    }));
  }
});

var _default = RemovableTextInput;
exports.default = _default;
module.exports = exports.default;